import axios from "axios";
import {OpenAPI as IdentityApi} from "./identity";
import {OpenAPI as PscApi} from "./psc";
import {OpenAPI as ChatApi} from "./chat-bot";
import {createRandomId} from "../utils/random";

export interface ErrorDetail {
    message: string;
    code: string;
}

export class ErrorDetailContainer {
    errors: ErrorDetail[];

    constructor(errors: ErrorDetail[]) {
        this.errors = errors;
    }

    getFirstError(): string {
        return this.errors[0].message;
    }

    hasError(code: string): boolean {
        return this.errors.some(
            (e) => e.code.toLowerCase() === code.toLowerCase()
        );
    }

    static fromString(error: string): ErrorDetailContainer {
        return new ErrorDetailContainer([{code: "", message: error}]);
    }
}

export default function setupOpenApi() {
    PscApi.BASE = process.env.REACT_APP_PSC_URL!;
    IdentityApi.BASE = process.env.REACT_APP_ID_URL!;
    ChatApi.BASE = process.env.REACT_APP_CHAT_BOT_URL!;

    const deviceId = getOrCreateDevice();

    PscApi.HEADERS = () => {
        const token = localStorage.getItem("access_token");
        return new Promise((resolver) => {
            resolver({
                Authorization: `Bearer ${token}`,
                did: deviceId
            });
        });
    };

    IdentityApi.HEADERS = () => {
        const token = localStorage.getItem("access_token");
        return new Promise((resolver) => {
            resolver({
                Authorization: `Bearer ${token}`,
            });
        });
    };

    ChatApi.HEADERS = () => {
        const token = localStorage.getItem("access_token");
        return new Promise((resolver) => {
            resolver({
                Authorization: `Bearer ${token}`,
            });
        });
    };

    axios.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            if (error["errors"]) {
                return Promise.reject(error);
            }

            if (error.response.status === 401) {
                console.log("getting 401");
                // do nothing otherwise a race condition will happen between anything here and user provider
                // trying to renew authentication
                return;
            }

            const errorContainer = new ErrorDetailContainer(
                error.response.data.errors
            );

            return Promise.reject(errorContainer);
        }
    );
}

function getOrCreateDevice(): string {
    let deviceId = localStorage.getItem('did');
    if (!deviceId) {
        deviceId = createRandomId(32);
        localStorage.setItem('did', deviceId);
    }
    return deviceId;
}
